module.exports = __webpack_public_path__ + "vc-icon.svg";